import { useEffect, useState, useRef } from 'react';
import { buscarLocalizacaoPiloto } from '../servicos/listagemServico';
import { cancelarViagemPeloCliente } from '../servicos/cadastroServico';
import Cookies from 'js-cookie';
import { useParams, useNavigate } from 'react-router-dom';
import { buscarDadosViagemPeloCliente } from '../servicos/listagemServico';
import LoadingIndicator from '../components/LoadingIndicator'

import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Corrige o ícone padrão do Leaflet que pode não aparecer
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

function MapaPilotoVindo() {

  const [dadosPiloto, setDadosPiloto] = useState(null);
  const [tempoEstimado, setTempoEstimado] = useState(null);
  const [statusViagem, setStatusViagem] = useState(''); 
  const [loadingIndicator, setLoadingIndicator] = useState(true);

  const [clienteLat, setClienteLat] = useState(null);
  const [clienteLng, setClienteLng] = useState(null);

  const navigate = useNavigate();
  const wakeLockRef = useRef(null);


  const iconeMoto = new L.Icon({
    iconUrl: '/imagens/icones/moto-verde-esportiva.png',
    iconSize: [55, 55],
  });

  const iconeUsuario = new L.Icon({
    iconUrl: '/imagens/icones/boneco1.png',
    iconSize: [65, 65],
  });

  // 🔹 Solicitar wake lock para manter a tela ativa
  const ativarWakeLock = async () => {
    console.log('Entrou em ativarWakeLock...');
    try {
      if ('wakeLock' in navigator) {
        wakeLockRef.current = await navigator.wakeLock.request('screen');
        console.log('Wake Lock ativado!');
        wakeLockRef.current.addEventListener('release', () => {
          console.log('Wake Lock liberado!');
        });
      }
    } catch (err) {
      console.warn('Não foi possível ativar o Wake Lock:', err);
    }
  };



  // Função para calcular tempo estimado de chegada (em minutos)
  const calcularTempoEstimado = (latPiloto, lngPiloto, latCliente, lngCliente) => {
    if (!latPiloto || !lngPiloto || !latCliente || !lngCliente) return null;

    const toRad = (valor) => (valor * Math.PI) / 180;
    const R = 6371; // raio da Terra em km
    const dLat = toRad(latCliente - latPiloto);
    const dLng = toRad(lngCliente - lngPiloto);

    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(toRad(latPiloto)) *
        Math.cos(toRad(latCliente)) *
        Math.sin(dLng / 2) ** 2;

    const distanciaKm = 2 * R * Math.asin(Math.sqrt(a));

    // Considera velocidade média 40km/h → tempo em minutos
    return Math.ceil((distanciaKm / 40) * 60);
  };

  const handleBuscarDadosViagemPeloCliente = async () => {
    console.log('! Entrou em handleBuscarDadosViagemPeloCliente...');

    // setLoadingIndicator(true);
  
    const cookies = Cookies.get();
    const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;
  
    if (!dadosCookies) {
      console.warn("Dados do cliente não encontrados nos cookies!");
      setLoadingIndicator(false);
      return;
    }
  
    console.log('dadosCookies antes: ');
    console.log(dadosCookies);
  
    try {
      console.log('Preparando para buscar dados da viagem....');
  
      const response = await buscarDadosViagemPeloCliente(dadosCookies);
  
      console.log('Response do buscarDadosViagemPeloCliente: ');
      console.log(response);
  
      // Atualiza os cookies com os dados corretos da viagem
      const novosDadosCookies = {
        ...dadosCookies,
        objViagem: response.objViagem,
      };
      Cookies.set('dadosCookies', JSON.stringify(novosDadosCookies), { expires: 60 });

      // 🔹 Atualiza status da viagem
      if (response?.objViagem?.nome_status) {
        setStatusViagem(response.objViagem.nome_status);
      }

      const cookies2 = Cookies.get();
      const dadosCookies2 = cookies2.dadosCookies ? JSON.parse(cookies2.dadosCookies) : null;

      console.log('cookies atualizados: ');
      console.log(dadosCookies2);
  
  
      // 🔹 Verifica status da viagem
      if (response?.objViagem?.nome_status === 'VIAGEM FINALIZADA') {
        console.warn('Viagem chegou ao fim!!!');
        alert('Sua viagem chegou ao fim. Obrigado por chamar o Melgs!');
        navigate('/');
      } else if (response?.objViagem?.nome_status === 'VIAGEM CANCELADA PELO PILOTO') {
        console.warn('Sua viagem foi cancelada pelo piloto!');
        alert('Sua viagem foi cancelada pelo piloto! Favor solicitar novamente.');
        navigate('/');
      }      
  
    } catch (e) {
      console.error('Erro ao buscar os dados da viagem:', e);
    } finally {
      setLoadingIndicator(false);
    }
  };

  

// useEffect do wakelock
useEffect(() => {
  const handleVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      ativarWakeLock();
    }
  };

  // ativa wake lock inicialmente
  ativarWakeLock();

  document.addEventListener('visibilitychange', handleVisibilityChange);

  return () => {
    document.removeEventListener('visibilitychange', handleVisibilityChange);
    if (wakeLockRef.current) {
      wakeLockRef.current.release().then(() => console.log('Wake Lock liberado no cleanup'));
    }
  };
}, []);




useEffect(() => {

  console.log('****************');
  console.log('Entrou no useEffect do MapaPilotoVindo.js....');

  const cookies = Cookies.get();
  const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;

  if (!dadosCookies || !dadosCookies.dadosInternauta) {
    console.warn("Dados do cliente não encontrados nos cookies!");
    return;
  }

  // const clienteLat = dadosCookies.dadosInternauta.latitude;
  // const clienteLng = dadosCookies.dadosInternauta.longitude;

const latCliente = dadosCookies.dadosInternauta.latitude;
const lngCliente = dadosCookies.dadosInternauta.longitude;

setClienteLat(latCliente);
setClienteLng(lngCliente);

const buscarDados = async () => {
  try {
    // setLoadingIndicator(true);
    const resposta = await buscarLocalizacaoPiloto(dadosCookies);

    if (resposta) {
      setDadosPiloto(resposta.objPiloto);

      const tempo = calcularTempoEstimado(
        resposta.latitude_piloto,
        resposta.longitude_piloto,
        latCliente,
        lngCliente
      );
      setTempoEstimado(tempo);
    }
  } catch (err) {
    console.error('Erro ao buscar dados do piloto:', err);
  } finally {
    setLoadingIndicator(false);
  }
};


  buscarDados(); // Executa uma vez ao montar

  const interval = setInterval(() => {
    handleBuscarDadosViagemPeloCliente();
    buscarDados(); // Executa a cada 15 segundos
  }, 10000);

  return () => clearInterval(interval);
  
}, []);




  // const alternarStatus = async (dadosPiloto, statusAtual) => {
  const handleCancelarViagemPeloCliente = async () => {
    console.log('Entrou em handleCancelarViagemPeloCliente...');

    setLoadingIndicator(true);

    const cookies = Cookies.get();
    const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;

    if (!dadosCookies || !dadosCookies.dadosInternauta) {
      console.warn("Dados do cliente não encontrados nos cookies!");
      return;
    }

    console.log('dadosCookies: ');
    console.log(dadosCookies);

    try {

      console.log('Preparando para cancelar a viagem....');

      const response = await cancelarViagemPeloCliente(dadosCookies);

      console.log('Response: ');
      console.log(response);

      navigate(`/`);

    } catch (e) {
      console.error('Erro ao cancelar a viagem:', e);
    }
  }


  if (!dadosPiloto) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100 px-3">
        <div className="text-center">
          <div
            className="spinner-border text-success mb-3"
            role="status"
            style={{ width: '2.5rem', height: '2.5rem' }}
          >
            <span className="visually-hidden">Carregando...</span>
          </div>
          <p className="fw-bold fs-6">Obtendo dados do piloto...</p>
        </div>
      </div>
    );
  }


  if (loadingIndicator) {
    return <LoadingIndicator fullscreen message="Aguarde..." />;
  }



  // Montar link do WhatsApp (remove caracteres não numéricos)
  const celular = dadosPiloto.numero_celular_com_ddd?.replace(/\D/g, '');
  const linkWhatsApp = celular ? `https://wa.me/55${celular}` : null;

  return (
    <div className="container-fluid px-3 mt-4">

    <h4
      className={`text-center mb-3 fw-bold p-3 rounded-4 shadow-sm ${
        statusViagem === 'VIAGEM INDO PARA O DESTINO FINAL'
          ? 'text-danger bg-warning' // vermelho no texto + fundo amarelo
          : 'text-success bg-warning'  // verde no texto + fundo claro
      }`}
      style={{ fontSize: '1.4rem' }}
    >
      <i className="bi bi-motorbike me-2"></i>
      {statusViagem === 'VIAGEM INDO PARA O DESTINO FINAL'
        ? 'Vá ao encontro do seu piloto!'
        : 'Seu piloto está a caminho!'}
    </h4>


      <div className="card shadow-sm border-0 rounded-4 p-3 mb-3">
        <div>
          <h5 className="fw-bold text-dark mb-2 text-truncate">
          🧍 {dadosPiloto.name || 'Piloto'}
          </h5>

          {/* <p className="mb-1 small">
            <strong>🧍Nome: </strong> {dadosPiloto.name || 'Não informado'}
          </p> */}

          <p className="mb-1 small">
            <strong>📋 Latitude: </strong> {dadosPiloto.latitude || 'Não informado'}
          </p>

          <p className="mb-1 small">
            <strong>📋 Longitude: </strong> {dadosPiloto.longitude || 'Não informado'}
          </p>

          <p className="mb-1 small">
            <strong>🏍 Moto: </strong>
            {dadosPiloto.marca_moto && dadosPiloto.modelo_moto && dadosPiloto.cor_moto
              ? `${dadosPiloto.marca_moto} ${dadosPiloto.modelo_moto} (${dadosPiloto.cor_moto})`
              : 'Não informado'}
          </p>

          <p className="mb-1 small">
            <strong>📋 Placa: </strong> {dadosPiloto.placa_moto || 'Não informado'}
          </p>

          {linkWhatsApp ? (
            <p className="mb-1 small">
              <strong>📞 Telefone: </strong> {dadosPiloto.numero_celular_com_ddd}
              <br />

              {statusViagem === 'VIAGEM INDO PARA O DESTINO FINAL' ? (
                <></>
              ) : (
                <>
                  <a
                    href={linkWhatsApp}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-1 d-inline-flex align-items-center text-success fw-bold small"
                    style={{ gap: '6px', textDecoration: 'none' }}
                  >
                    <i className="fab fa-whatsapp" style={{ fontSize: '18px' }}></i>
                    Conversar no WhatsApp
                  </a>
                </>
              )}

            </p>
          ) : (
            <p className="small"><strong>📞 Telefone:</strong> Não informado</p>
          )}
        </div>
      </div>  




      <div className="text-center">
        {tempoEstimado !== null ? (
          <div className="alert alert-success p-2 fs-6 fw-bold shadow-sm rounded-4" role="alert">
            <i className="bi bi-clock me-2"></i>

            {statusViagem === 'VIAGEM INDO PARA O DESTINO FINAL' ? (
              <span>Seu piloto chegou! Boa viagem!</span>
            ) : (
              <>
                Tempo estimado de chegada:{' '}
                <span className="text-dark">{tempoEstimado} min</span>
              </>
            )}

            
          </div>
        ) : (
          <div className="alert alert-warning p-2 fs-6" role="alert">
            Não foi possível calcular o tempo de chegada.
          </div>
        )}
      </div>


      {/* Mapa mostrando cliente e piloto */}
      {dadosPiloto.latitude && dadosPiloto.longitude && clienteLat && clienteLng && (
        <div className="card shadow-sm border-0 rounded-4 p-2 mb-3">
          <MapContainer
            center={[dadosPiloto.latitude, dadosPiloto.longitude]}
            zoom={14}
            style={{ height: '300px', width: '100%', borderRadius: '12px' }}
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution="&copy; OpenStreetMap contributors"
            />


  {/* Ajustar mapa entre cliente e piloto */}
  <AjustarMapa
    clienteLat={clienteLat}
    clienteLng={clienteLng}
    pilotoLat={dadosPiloto.latitude}
    pilotoLng={dadosPiloto.longitude}
  />
            {/* Marcador do piloto */}
            <Marker position={[dadosPiloto.latitude, dadosPiloto.longitude]} icon={iconeMoto}>
              <Popup>Piloto: {dadosPiloto.name || 'Sem nome'}</Popup>
            </Marker>

            {/* Marcador do cliente */}
            <Marker position={[clienteLat, clienteLng]} icon={iconeUsuario}>
              <Popup>Você está aqui</Popup>
            </Marker>
          </MapContainer>
        </div>
      )}




      {/* Botão Cancelar Viagem */}
      <div className="d-grid mt-3">
        <button 
          className="btn btn-danger btn-lg"
          onClick={handleCancelarViagemPeloCliente}
        >
          <i className="bi bi-x-circle me-2"></i> Cancelar Viagem
        </button>

      </div>
    </div>
  );
}

export default MapaPilotoVindo;



// criar uma função para ajustar o mapa
function AjustarMapa({ clienteLat, clienteLng, pilotoLat, pilotoLng }) {
  const map = useMap();

  useEffect(() => {
    if (map && clienteLat && clienteLng && pilotoLat && pilotoLng) {
      const bounds = L.latLngBounds([
        [clienteLat, clienteLng],
        [pilotoLat, pilotoLng],
      ]);
      map.fitBounds(bounds, { padding: [50, 50] });
    }
  }, [map, clienteLat, clienteLng, pilotoLat, pilotoLng]);

  return null;
}
